import {EntityInfoWindow, EntityInfoWindowProps} from "../EntityInfoWindow/EntityInfoWindow";
import {firstOrUndefined, SiteEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Anchor, Text} from "@mantine/core";
import {useMemo} from "react";
import {Link} from "react-router-dom";

export type SiteInfoWindowProps = EntityInfoWindowProps<SiteEntity>

export const SiteInfoWindow = (props: SiteInfoWindowProps) => {
  const {entity: site, ...rest} = props;
  const {t} = useTranslation("common");

  const routeName = useMemo(() => {
    let name: string | undefined = undefined

    const route = firstOrUndefined(site.routes)
    if (route) {
      name = route.name
      if (route.routeGroupName) {
        name += ` (${route.routeGroupName})`
      }
    }

    return name
  }, [site]);

  return (
    <EntityInfoWindow {...rest} entity={site}>
      <Anchor component={Link} to={`/sites/profile?id=${site.id}`}>
        {site.name}
      </Anchor>
      <Text>{site.companyName ?? "-"}</Text>
      {routeName && (
        <Text>
          {t("ots.ui.entity.site.map.infowindow.routes", "Routes: {{routeName}}", {
            routeName: routeName
          })}
        </Text>
      )}
    </EntityInfoWindow>
  );
};
